import { onSnapshot, type Unsubscribe } from 'firebase/firestore'
import { refs } from '../models/base/firestore-refs'
import type { SystemConfig, SystemConfigDoc } from '../models/config/system.modl'
import { toSystemConfig } from '../models/config/system.modl'

/**
 * config/system ドキュメントの購読を行うサービス
 */
export class SystemConfigService {
  /**
   * システム設定（config/system）を購読する
   * @param onNext - ドキュメント取得・更新時に呼ばれる（存在しない場合は null）
   * @param onError - エラー時に呼ばれる
   * @returns 購読解除関数
   */
  subscribeSystemConfig(
    onNext: (config: SystemConfig | null) => void,
    onError?: (error: Error) => void,
  ): Unsubscribe {
    const docRef = refs.systemConfig()
    return onSnapshot(
      docRef,
      (snap) => {
        if (!snap.exists()) {
          onNext(null)
          return
        }
        try {
          const config = toSystemConfig(snap.id, snap.data() as SystemConfigDoc, snap.ref.path)
          onNext(config)
        } catch (err) {
          const e = err instanceof Error ? err : new Error('システム設定の取得に失敗しました')
          if (onError) onError(e)
        }
      },
      (err) => {
        const e = err instanceof Error ? err : new Error('システム設定の監視に失敗しました')
        if (onError) onError(e)
      },
    )
  }
}
